<template>
  <div class="aiaibot-media-widget">
    <AiaiBotMessageHeader
      v-if="!hideHeader"
      :date="date"
      :agent-name="agentName"
    />
    <div
      v-if="message.mediaType === 'link'"
      class="aiaibot-content tw-p-4 tw-bg-white tw-rounded-t-lg tw-rounded-r-lg"
    >
      <a :href="message.url" target="_blank">
        {{ message.description }}
      </a>
    </div>
    <a
      v-else-if="message.mediaType === 'image'"
      :href="message.url"
      target="_blank">
      <img
        :src="message.url"
        class="image tw-rounded-tl-lg tw-rounded-br-lg"
      />
    </a>
  </div>
</template>

<script>
import AiaiBotMessageHeader from './AiaiBotMessageHeader.vue'

export default {
  name: 'AiaiBotMediaMessage',
  components: {
    AiaiBotMessageHeader
  },
  props: {
    date: {
      type: Date
    },
    message: {
      type: Object,
      default: () => {}
    },
    hideHeader: {
      type: Boolean
    },
    agentName: {
      type: String,
      default: ''
    }
  },
  setup () {
    return {
    }
  }
}
</script>

<style lang="postcss" scoped>
.aiaibot-media-widget {
  flex: 1;
  display: flex;
  justify-content: flex-end;
}

.image {
  max-width: 100%;
  max-height: 213px;
}
</style>